import { observable } from 'mobx';

export type TripApproveItemResponseArgs = {
  id: number;
  trip_id: number;
  json: string;
};

export type TripApproveItemArgs = {
  id: number;
  tripId: number;
  json: string;
};

export const convertTripApproveItemResponseToArgs = (
  response: TripApproveItemResponseArgs
): TripApproveItemArgs => {
  return {
    id: response.id,
    tripId: response.trip_id,
    json: response.json
  };
};

export default class TripApproveItem {
  @observable
  id: number;

  @observable
  tripId: number;

  @observable
  json: string;

  constructor(args: TripApproveItemArgs) {
    this.id = args.id;
    this.tripId = args.tripId;
    this.json = args.json;
  }
}
